import type { Cart } from "@packages/sdk";

import type { HallowCartGrant } from "../types/enums/hallowCartGrant.types";

type GetCartGrantProps = {
  cart: Cart;
  filter?: (variables: any) => boolean;
  grant: HallowCartGrant;
};

export const getCartGrant = ({
  cart,
  filter,
  grant: grantName,
}: GetCartGrantProps) =>
  cart?.promo_code?.grants.find(
    (grant) => grant.name === grantName && (!filter || filter(grant.variables)),
  );
